import FormStep, { FormFields, FormStepControls } from "../FormStep";
import { welcomeFields } from "./fields";

export default function WelcomeStep(props) {
  const { step, goNext, goPrev, isLoading, ...otherProps } = props;

  return (
    <FormStep
      step={step}
      title="Welcome to qoohoo!"
      description="Let’s start with your introduction"
      sideTitle={"Automate & Monetise"}
      sideDescription={
        "Automate your entire process & monetise your communities on any platform"
      }
      sideImage={"/assets/illustrations/onboarding-1.svg"}
    >
      <FormFields fields={welcomeFields} {...otherProps} />

      <FormStepControls
        isLoading={isLoading}
        step={step}
        goNext={goNext}
        goPrev={goPrev}
      />
    </FormStep>
  );
}
